import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { TAG_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import { createSuggestionPlugin } from 'hubspot-prosemirror/prosemirror/plugins/suggestion';
import { HR } from 'foundations-components/transitional/components/HR';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SnippetsNotFound() {
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs("div", {
      className: "suggestion-item",
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "draftPlugins.snippetsPlugin.resultsZeroState.text"
      }), /*#__PURE__*/_jsx(HR, {
        marginBlockEnd: "0"
      }), /*#__PURE__*/_jsx("a", {
        href: `/snippets/${PortalIdParser.get()}/new`,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "draftPlugins.snippetsPlugin.resultsZeroState.link"
        })
      })]
    })
  );
}
export const configureSnippetsPlugin = ({
  snippetFunctions,
  supplementalObjects,
  contactEmail,
  contactVid
}) => createSuggestionPlugin({
  getSuggestions: (text, done) => {
    return snippetFunctions.searchSnippets({
      count: 20,
      offset: 0,
      query: text
    }).then(snippets => {
      const transformedSnippets = snippets.get('results').toJS().map(snippet => ({
        searchText: snippet.name,
        text: snippet.name,
        id: snippet.contentId
      }));
      done(transformedSnippets);
    });
  },
  fetchSelectSuggestion: ({
    snippet,
    handleInsert
  }) => {
    return snippetFunctions.fetchRenderedContent({
      id: snippet.id,
      contactEmail,
      contactVid,
      supplementalObjects
    }).then(data => handleInsert({
      html: data.htmlBody
    }));
  },
  type: TAG_MENTION,
  NotFoundComponent: SnippetsNotFound
});